export default __webpack_public_path__ + "static/media/chipperParts.0afe3f6e.png";